module.exports = __webpack_public_path__ + "static/img/third18.546e148e.png";